<h2 mat-dialog-title [hidden]="!skipFlag">એપ્લિકેશન અપડેટ ઉપલબ્ધ છે. અપડેટ કરવા માટે હા/ના પસંદ કરો.</h2>

<h2 mat-dialog-title [hidden]="skipFlag">એપ્લિકેશન અપડેટ ઉપલબ્ધ છે. એપ્લિકેશન અપડેટ કરો.</h2>

<div mat-dialog-actions>
  <button mat-button [hidden]="skipFlag" (click)="onClickupdate()">અપડેટ</button>
  <button mat-button [mat-dialog-close]="true" [hidden]="!skipFlag">હા</button>
  <button mat-button [mat-dialog-close]="false" [hidden]="!skipFlag">ના</button>
</div>